<template>
  <div class="topSearch">
    <el-row :gutter="20">
      <el-col :span="24">
        <div style="display:flex;justify-content: center;">
          <div class="top1" style="margin-right:30px">
            <a @click="clickLogo"><img src="@/assets/sylogo.png" alt="" /></a>
          </div>
          <div class="top2">
            <div class="grid-content bg-purple-dark" style="width:600px;margin-right:30px">
              <el-input :placeholder="placeholder" v-model="searchValue" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
              </el-input>
            </div>
          </div>
          <div class="top3" style="width:140px">
            <div class="grid-content bg-purple-dark">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <img :src="langImage" style="width:20px;margin-right: 10px;vertical-align:middle;" />{{ langValue }}<i
                    class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="中文"><img src="@/assets/langicon/cn.png"
                      style="width:20px;margin-right: 10px;" />中文</el-dropdown-item>
                  <el-dropdown-item command="English"><img src="@/assets/langicon/us.png"
                      style="width:20px;margin-right: 10px;" />English</el-dropdown-item>
                  <el-dropdown-item command="한국어"><img src="@/assets/langicon/kr.png"
                      style="width:20px;margin-right: 10px;" />한국어</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-col>

      <!-- <el-col :span="3" :offset="4">
        <img src="@/assets/sylogo.png" alt="" />
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple-dark">
          <el-input placeholder="请输入产品" v-model="searchValue" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
          </el-input>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple-dark">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <img :src="langImage" style="width:20px;margin-right: 10px;vertical-align: baseline;" />{{ langValue }}<i
                class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="中文"><img src="@/assets/langicon/cn.png"
                  style="width:20px;margin-right: 10px;" />中文</el-dropdown-item>
              <el-dropdown-item command="English"><img src="@/assets/langicon/us.png"
                  style="width:20px;margin-right: 10px;" />English</el-dropdown-item>
              <el-dropdown-item command="한국어"><img src="@/assets/langicon/kr.png"
                  style="width:20px;margin-right: 10px;" />한국어</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
export default {
  name: "TopSearch",
  data() {
    return {
      searchValue: "",
      langValue: "Language",
      langImage: require("@/assets/language.png"),
      lang: 'zh-CN',
      options: [{
        value: 'zh-CN',
        label: '中文'
      }, {
        value: 'zh-EN',
        label: 'English'
      }, {
        value: '한국어',
        label: '한국어'
      }],
      navList: [
        { name: "/", navItem: "首页" },
        { name: "/aboutUs", navItem: "关于我们" },
        { name: "/news", navItem: "企业新闻" },
        { name: "/showProduct", navItem: "产品展示" },
        { name: "/Cooperative", navItem: "合作品牌" },
        { name: "/contactUs", navItem: "联系我们" },
      ],
    };
  },
  computed: {
    placeholder: function () {
      return this.$t('home.placeholder')
    }
  },
  created() {
    const lang = localStorage.getItem('lang')
    this.lang = lang;
    this.$i18n.locale = lang;
    if (this.lang == 'zh-CN') {
      this.langImage = require('@/assets/langicon/cn.png');
      this.langValue = '中文';

    } else if (this.lang == 'zh-EN') {
      this.langImage = require('@/assets/langicon/us.png');
      this.langValue = 'English';
    } else {
      this.langImage = require('@/assets/langicon/kr.png');
      this.langValue = '한국어';
    }

  },

  methods: {
    // 更改语言方法监听
    handleCommand(command) {
      this.langValue = command;
      switch (command) {
        case '中文':
          this.$i18n.locale = "zh-CN"; //关键语句
          this.langImage = require('@/assets/langicon/cn.png');

          break;
        case 'English':
          this.$i18n.locale = "zh-EN"; //关键语句
          this.langImage = require('@/assets/langicon/us.png');
          break;
        case '한국어':
          this.$i18n.locale = "zh-KN"; //关键语句
          this.langImage = require('@/assets/langicon/kr.png');
          break;
        default:
          break;
      }
      localStorage.setItem("lang", this.$i18n.locale)
      // console.log(this.$i18n.locale)
      this.$router.push('/home')
      location.reload()
      
    },

    // 搜索框监听
    searchClick() {
      console.log(this.searchValue);
      this.$router.replace({ path: "/empty?words=" + this.searchValue })

    },
    // 点击logo跳转首页
    clickLogo() {
      console.log("shouye")
      this.$router.push("/home")
    }

  },

}
</script>

<style lang="less">
a {
  cursor: pointer;
}

.topSearch {
  background-color: white;
  padding-top: 20px;
  line-height: 40px;

  .el-row {
    margin: 0px !important;
  }
}

.top1 img {
  width: 150px;
}
</style>